import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import WatchlistNotesTable from "../../../../components/ui/WatchlistNotesTable";
import { ComplianceAPI } from "../../../../api/compliance";
import { getWatchlistNotesColumns } from "./getWatchlistNotesColumns";
import { fundedComplianceProfileActions } from "../../../../reducers/fundedComplianceProfile";

const WatchlistNotes: React.FC = () => {
  const params: { id: string } = useParams();
  const { watchlist_notes } = useSelector((state) => state.fundedComplianceProfile);
  const { rows } = watchlist_notes.data.results;

  const compliance_entries_id = +params.id;

  const getInitialValues = useMemo(
    () => (editIds: number[]) => {
      const noteToEdit = rows.find((note) => note.ids?.toString() === editIds.toString());
      return {
        reason: noteToEdit?.reason || "",
        measure_taken: noteToEdit?.measure_taken || "",
        compliance_entries_id,
        email: noteToEdit?.account?.email,
        assignedEmail: noteToEdit?.account?.email,
      };
    },
    [rows, compliance_entries_id]
  );

  const getColumns = useMemo(
    () => (onEditNote: (ids: number[]) => void) => getWatchlistNotesColumns({ onEditNote }),
    []
  );

  const handleFetchNotes = async (query: URLSearchParams, signal: AbortSignal | undefined) => {
    query.append("compliance_entries_id", compliance_entries_id.toString());
    query.append("use_grouping", "true");
    return await ComplianceAPI.getSearchNotes(query.toString(), signal);
  };

  return (
    <WatchlistNotesTable
      rows={rows}
      isLoading={watchlist_notes.isLoading}
      onFetchNotes={handleFetchNotes}
      onFetchRequest={() => fundedComplianceProfileActions.fetchWatchlistNotesRequest()}
      onFetchSuccess={(data) => fundedComplianceProfileActions.fetchWatchlistNotesSuccess(data)}
      onFetchError={() => fundedComplianceProfileActions.fetchWatchlistNotesFailed()}
      getInitialValues={getInitialValues}
      getColumns={getColumns}
      queryKey={[compliance_entries_id]}
    />
  );
};

export default WatchlistNotes;
